import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

interface SystemInfo {
  db_groesse_bytes: number;
  mandanten_gesamt: number;
  benutzer_gesamt: number;
  benutzer_aktiv: number;
  alembic_version: string | null;
}

const kachelStil: React.CSSProperties = {
  border: '1px solid var(--border-color, #ddd)',
  padding: '16px 20px',
  minWidth: '160px',
};

const SystemPanel: React.FC<{ authToken: string }> = ({ authToken }) => {
  const [info, setInfo] = useState<SystemInfo | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/superadmin/system`, {
      headers: { Authorization: `Bearer ${authToken}` },
    })
      .then(r => setInfo(r.data))
      .catch(e => setFehler(e.response?.data?.detail || 'Systeminfo nicht verfügbar.'));
  }, [authToken]);

  if (fehler) return <div style={{ padding: 24 }}>{fehler}</div>;
  if (!info) return <div style={{ padding: 24 }}>Lade Systeminfo …</div>;

  const mb = (info.db_groesse_bytes / (1024 * 1024)).toFixed(1);
  const kacheln: Array<[string, string]> = [
    ['Datenbank', `${mb} MB`],
    ['Mandanten', String(info.mandanten_gesamt)],
    ['Benutzer gesamt', String(info.benutzer_gesamt)],
    ['Benutzer aktiv', String(info.benutzer_aktiv)],
    ['Migrations-Stand', info.alembic_version ?? 'unbekannt'],
  ];

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, padding: 24 }}>
      {kacheln.map(([label, wert]) => (
        <div key={label} style={kachelStil}>
          <div style={{ fontSize: 12, opacity: 0.7, textTransform: 'uppercase' }}>{label}</div>
          <div style={{ fontSize: 24, fontWeight: 600, marginTop: 4 }}>{wert}</div>
        </div>
      ))}
    </div>
  );
};

export default SystemPanel;
